<template>
  <div class="" testek="product-detail">
    <BaseDetail
      @viewDetail="viewDetail"
      @addData="addData"
      @addMoreData="addMoreData"
      :currentItem="currentItem"
      :titleDetail="$t('i18nCommon.TitleProductId')"
    >
      <template #header>
        <div class="font-bold text-xl mb-4">
          {{ title }}
        </div>
      </template>
      <template #content>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              class="demo-ruleForm"
              :size="formSize"
              status-icon
              label-position="left"
            >
              <a-form-item
                prop="Id"
                testek="Id"
                class="columns-1 w-full"
                v-if="mode == $enum.Mode.Edit"
                labelAlign="left"
              >
                <div class="flex">
                  <div class="font-bold min-w-32">ID</div>
                  <a-input v-model:value="ruleForm.id" />
                </div>
              </a-form-item>
              <div class="flex columns-2">
                <a-form-item
                  prop="category"
                  testek="category"
                  class="w-full"
                  labelAlign="left"
                >
                  <div class="mr-8 flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Category") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-select
                      v-model:value="ruleForm.category"
                      show-search
                      :placeholder="$t('i18nCommon.Category')"
                      :filterOption="false"
                      @focus="loadDataCategory"
                      @change="onChangeCategory"
                      @search="filterDataCategory"
                      class="w-full"
                      :popupClassName="'dropdown-menu-category'"
                      :field-names="{
                        label: `categoryName`,
                        value: `id`,
                      }"
                      :options="categoryFilters"
                    >
                      <template #option="{ isTitle, categoryName, cateDesc }">
                        <tr
                          :class="isTitle ? 'font-bold select-title' : ''"
                          :disabled="isTitle"
                          @click="isTitle ? $event.stopPropagation() : null"
                        >
                          <td class="td-item td-item-category">
                            {{ categoryName }}
                          </td>
                          <td class="td-item td-item-category">
                            {{ cateDesc }}
                          </td>
                        </tr>
                      </template>
                    </a-select>
                  </div>
                </a-form-item>
                <a-form-item
                  prop="supplier"
                  testek="supplier"
                  class="w-full"
                  labelAlign="left"
                >
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Supplier") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>

                    <a-select
                      v-model:value="ruleForm.suppliers"
                      show-search
                      :placeholder="$t('i18nCommon.Supplier')"
                      :filterOption="false"
                      @focus="loadDataSupplier"
                      @change="onChangeSupplier"
                      @search="filterDataSupplier"
                      testek="supplier-combobox"
                      class="w-full"
                      :popupClassName="'dropdown-menu-supplier'"
                      :options="supplierFilters"
                      :field-names="{
                        label: `supName`,
                        value: `id`,
                      }"
                    >
                      <template
                        #option="{ isTitle, supName, supContactName, supAddress }"
                      >
                        <tr
                          :class="isTitle ? 'font-bold select-title' : ''"
                          @click="isTitle ? $event.stopPropagation() : null"
                          :disabled="isTitle"
                        >
                          <td
                            class="td-item td-item-supplier"
                            :class="isTitle ? 'font-bold' : ''"
                          >
                            {{ supName }}
                          </td>
                          <td
                            class="td-item td-item-supplier"
                            :class="isTitle ? 'font-bold' : ''"
                          >
                            {{ supContactName }}
                          </td>

                          <td
                            class="td-item td-item-supplier"
                            :class="isTitle ? 'font-bold' : ''"
                          >
                            {{ supAddress }}
                          </td>
                        </tr>
                      </template>
                    </a-select>
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="code" testek="code" class="w-full" labelAlign="left">
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Code") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.code" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item
                  prop="name"
                  testek="name"
                  class="mr-8 w-full"
                  labelAlign="left"
                >
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Name") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.name" />
                  </div>
                </a-form-item>
                <a-form-item prop="unit" testek="unit" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Unit") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.unit" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item
                  prop="description"
                  testek="description"
                  class="w-full"
                  labelAlign="left"
                >
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Description") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.description" class="w-full" />
                  </div>
                </a-form-item>
              </div>
              <!-- <div class="flex columns-1">
                <a-form-item
                  prop="image"
                  testek="image"
                  class="w-full"
                  labelAlign="left"
                >
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Image") }}
                    </div>
                    <a-upload
                      :file-list="fileList"
                      :remove="handleRemove"
                      :before-upload="beforeUpload"
                    >
                      <a-button>
                        <upload-outlined></upload-outlined>
                        Click to Upload
                      </a-button>
                    </a-upload>
                  </div>
                </a-form-item>
              </div> -->
              <div class="flex columns-2">
                <a-form-item
                  prop="price"
                  testek="price"
                  class="mr-8 w-full"
                  labelAlign="left"
                >
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Price") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input-number
                      class="w-full"
                      v-model:value="ruleForm.price"
                      addon-after="VND"
                    ></a-input-number>
                  </div>
                </a-form-item>
                <a-form-item
                  prop="quantity"
                  testek="quantity"
                  class="w-full"
                  labelAlign="left"
                >
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Quantity") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input-number
                      class="w-full"
                      v-model:value="ruleForm.quantity"
                    ></a-input-number>
                  </div>
                </a-form-item>
              </div>
              <a-form-item class="mt-6">
                <div class="flex">
                  <a-button
                    type="primary"
                    testek="btn-add"
                    @click="submitForm()"
                    class="mr-4"
                  >
                    {{ $t("i18nCommon.Add") }}
                  </a-button>
                  <a-button type="primary" testek="btn-add-more" @click="addMoreData()">
                    {{ $t("i18nCommon.AddMore") }}
                  </a-button>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </template>
    </BaseDetail>
    <div v-if="isShow && product">
      <a-modal v-model:open="isShow" centered :width="800" :closable="false">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.Product") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form :size="formSize" status-icon label-position="left">
              <div class="flex">
                <div class="flex-1">
                  <div class="flex columns-1">
                    <a-form-item
                      prop="category"
                      testek="category"
                      class="w-full"
                      labelAlign="left"
                    >
                      <div class="flex">
                        <div class="flex min-w-32 font-bold">
                          {{ $t("i18nProduct.Category") }}
                        </div>
                        <a-input
                          v-model:value="product.category.categoryName"
                          :disabled="true"
                        />
                      </div>
                    </a-form-item>
                  </div>
                  <div class="flex columns-1">
                    <a-form-item
                      prop="supplier"
                      testek="supplier"
                      class="w-full"
                      labelAlign="left"
                    >
                      <div class="flex items-center">
                        <div class="flex min-w-32 font-bold">
                          {{ $t("i18nProduct.Supplier") }}
                        </div>
                        <a-input
                          v-model:value="product.supplier.supName"
                          :disabled="true"
                        />
                      </div>
                    </a-form-item>
                  </div>
                  <div class="flex columns-1">
                    <a-form-item
                      prop="code"
                      testek="code"
                      class="w-full"
                      labelAlign="left"
                    >
                      <div class="flex items-center">
                        <div class="flex min-w-32 font-bold">
                          {{ $t("i18nProduct.Code") }}
                        </div>
                        <a-input v-model:value="product.productCode" :disabled="true" />
                      </div>
                    </a-form-item>
                  </div>
                  <div class="flex columns-1">
                    <a-form-item
                      prop="name"
                      testek="name"
                      class="w-full"
                      labelAlign="left"
                    >
                      <div class="flex items-center">
                        <div class="flex min-w-32 font-bold">
                          {{ $t("i18nProduct.Name") }}
                        </div>
                        <a-input v-model:value="product.productName" :disabled="true" />
                      </div>
                    </a-form-item>
                  </div>
                </div>
                <div class="flex flex-1 justify-center items-center">
                  <div class="logo-product-default h-64 w-64"></div>
                </div>
              </div>
              <div class="flex columns-1 mt-6">
                <a-form-item prop="unit" testek="unit" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Unit") }}
                    </div>
                    <a-input v-model:value="product.unit" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item
                  prop="description"
                  testek="description"
                  class="w-full"
                  labelAlign="left"
                >
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Description") }}
                    </div>
                    <a-input
                      v-model:value="product.productDesc"
                      class="w-full"
                      :disabled="true"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item
                  prop="price"
                  testek="price"
                  class="mr-8 w-full"
                  labelAlign="left"
                >
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Price") }}
                    </div>
                    <a-input
                      class="w-full"
                      v-model:value="product.price"
                      addon-after="VND"
                      :disabled="true"
                    ></a-input>
                  </div>
                </a-form-item>
                <a-form-item
                  prop="quantity"
                  testek="quantity"
                  class="w-full"
                  labelAlign="left"
                >
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Quantity") }}
                    </div>
                    <a-input
                      class="w-full"
                      v-model:value="product.quantity"
                      :disabled="true"
                    ></a-input>
                  </div>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { ModuleProduct, ModuleCategory, ModuleSupplier } from "@/store/module-const";
import { mapActions, mapGetters } from "vuex";
import BaseDetail from "@/views/base/BaseDetail.vue";
import _ from "lodash";
export default {
  name: "ProductDetail",
  components: {
    BaseDetail,
  },
  data() {
    return {
      ruleForm: {},
      rules: {},
      statuses: [],
      currentItem: {},
      fileList: [],
      isShow: false,
      product: {},
      mode: this.$enum.Mode.Add,
    };
  },
  computed: {
    ...mapGetters(ModuleCategory, ["Categories"]),
    ...mapGetters(ModuleSupplier, ["Suppliers"]),
    title() {
      if (this.mode == this.$enum.Mode.Edit) return this.$t("i18nCommon.EditProduct");
      return this.$t("i18nCommon.AddProduct");
    },
    categoryFilters() {
      const me = this;
      let firstData = {
        categoryName: me.$t("i18nCommon.CategoryInfo.CategoryName"),
        cateDesc: me.$t("i18nCommon.CategoryInfo.CategoryDescription"),
        isTitle: true,
      };

      if (!me.Categories || me.Categories.length <= 0) {
        return [firstData];
      }

      let categories = [firstData, ...me.Categories];
      return categories;
    },

    supplierFilters() {
      const me = this;
      let firstData = {
        supName: me.$t("i18nCommon.SupplierInfo.Name"),
        supContactName: me.$t("i18nCommon.SupplierInfo.ContactName"),
        supAddress: me.$t("i18nCommon.SupplierInfo.Address"),
        isTitle: true,
      };

      if (!me.Suppliers || me.Suppliers.length <= 0) {
        return [firstData];
      }

      let suppliers = [firstData, ...me.Suppliers];
      return suppliers;
    },
  },
  created() {
    const me = this;
    me.initDataStatic();
    //Lắng nghe sự kiện
    me.$emitter.on("LoadEditProduct", me.loadDataEdit);
  },
  beforeDestroy() {
    const me = this;
    me.$emitter.off("LoadEditProduct", me.loadDataEdit);
  },
  methods: {
    ...mapActions(ModuleProduct, ["createProduct", "getProduct", "updateProduct"]),
    ...mapActions(ModuleCategory, ["getCategoriesList"]),
    ...mapActions(ModuleSupplier, ["getSuppliersList"]),
    initDataStatic() {
      const me = this;
      me.rules = {
        category: [
          {
            required: true,
            message: `${me.$t("i18nProduct.CategoryInvalid")}`,
            trigger: ["change", "blur"],
          },
        ],
        supplier: [
          {
            required: true,
            message: `${me.$t("i18nProduct.SupplierInvalid")}`,
            trigger: ["change", "blur"],
          },
        ],
        code: [
          {
            required: true,
            message: `${me.$t("i18nProduct.CodeInvalid")}`,
            trigger: "blur",
          },
        ],
        quantity: [
          {
            required: true,
            message: `${me.$t("i18nProduct.QuantityInvalid")}`,
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            message: `${me.$t("i18nProduct.PriceInvalid")}`,
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: `${me.$t("i18nProduct.DescriptionInvalid")}`,
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: `${me.$t("i18nProduct.NameInvalid")}`,
            trigger: "blur",
          },
        ],
        unit: [
          {
            required: true,
            message: `${me.$t("i18nProduct.UnitInvalid")}`,
            trigger: "blur",
          },
        ],
      };
    },
    loadDataEdit: _.debounce(async function (payload) {
      const me = this;
      if (!payload) return;
      me.mode = payload.mode;

      //load danh mục
      await me.loadDataCategory();

      //load nhà cung cấp
      await me.loadDataSupplier();

      setTimeout(async () => {
        let product = await me.getProduct({ id: payload.id });
        if (product) {
          me.ruleForm = {
            id: product.id,
            category: product.category ? product.category.id : null,
            code: product.productCode,
            description: product.productDesc,
            name: product.productName,
            price: product.price,
            quantity: product.quantity,
            supplier: product.supplier ? product.supplier.id : null,
            unit: product.unit,
          };
        }
      }, 300);
    }, 300),
    async submitForm(isReset = true) {
      const me = this;
      let formEl = me.$refs.ruleFormRef;
      if (!formEl) return;

      formEl
        .validate()
        .then(async () => {
          if (me.mode == me.$enum.Mode.Edit) {
            await me.editData();
          } else {
            await me.addData(isReset);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },

    onChangeCategory: _.debounce(function (payload) {
      const me = this;
      let category = me.Categories.find((x) => x.id == payload);
      if (category) {
        me.ruleForm.category = category.id;
      }
    }, 500),

    onChangeSupplier: _.debounce(function (payload) {
      const me = this;
      let supplier = me.Suppliers.find((x) => x.id == payload);
      if (supplier) {
        me.ruleForm.supplier = supplier.id;
      }
    }, 500),

    onChangeStatus: _.debounce(function (payload) {
      const me = this;
      let status = me.statuses.find((x) => x.id == payload);
      if (status) {
        me.ruleForm.status = status.id;
      }
    }, 500),

    addMoreData: _.debounce(async function () {
      const me = this;
      await me.submitForm(false);
    }, 300),

    addData: _.debounce(async function (isReset = true) {
      const me = this;
      let result = await me.createProduct(me.ruleForm);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nProduct.AddProductSuccess")
        );
        if (isReset == true) {
          me.ruleForm = {};
        }
        // me.$router.push("/product");
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nProduct.AddProductFail"),
          "warning"
        );
      }
    }, 300),

    editData: _.debounce(async function () {
      const me = this;
      let result = await me.updateProduct(me.ruleForm);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditProductSuccess")
        );
        me.ruleForm = {};
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditProductFail"),
          "warning"
        );
      }
    }, 300),

    viewDetail: _.debounce(async function (params) {
      const me = this;
      if (!params || !params.id) return;

      //lấy dữ liệu chi tiết từ API
      me.product = await me.getProduct({ id: params.id });
      if (me.product) {
        me.isShow = true;
      } else {
      }
      //Show form chi tiết
    }, 300),

    loadDataCategory: _.debounce(async function () {
      const me = this;
      if (me.Categories && me.Categories.length > 0) return;
      await me.getCategoriesList();
    }, 300),

    loadDataSupplier: _.debounce(async function () {
      const me = this;
      if (me.Suppliers && me.Suppliers.length > 0) return;
      await me.getSuppliersList();
    }, 300),

    loadDataStatus: _.debounce(async function () {
      const me = this;
      me.statuses = this.$config.StatusInfos;
    }, 300),

    filterDataSupplier: _.debounce(async function (searchText) {
      const me = this;
      await me.getSuppliersList({
        keyword: searchText,
      });
    }, 500),
    filterDataCategory: _.debounce(async function (searchText) {
      const me = this;
      await me.getCategoriesList({
        keyword: searchText,
      });
    }, 300),

    beforeUpload(file) {
      const me = this;
      me.fileList = [file];
      return false;
    },
    handleRemove(file) {
      const me = this;
      const index = me.fileList.indexOf(file);
      const newFileList = me.fileList.slice();
      newFileList.splice(index, 1);
      me.fileList = newFileList;
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
  background-color: initial !important;
  border-color: initial !important;
}
</style>
